import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const profileSettingsPageK = {
  profileSettings: "profile_settings_page.profileSettings",
  changePassword: "profile_settings_page.changePassword",
  account: "profile_settings_page.account",
  logout: "profile_settings_page.logout",
  general: "profile_settings_page.general",
};

export const useProfileSettingsPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      profileSettings: t(profileSettingsPageK.profileSettings),
      changePassword: t(profileSettingsPageK.changePassword),
      account: t(profileSettingsPageK.account),
      logout: t(profileSettingsPageK.logout),
      general: t(profileSettingsPageK.general),
    }),
    [i18n.language]
  );
};